import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { TravelReimbursementService } from '../../services/travel-reimbursement.service';
import { reimbursementUrl, itineraryRBUrl, BOOKINGTYPE, BOOKINGMETHOD, PURPOSE } from 'src/app/modules/shared/common/api';
import { TravelReimbursementCancelComponent } from '../travel-reimbursement-cancel/travel-reimbursement-cancel.component';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { ItineraryDetailsComponent } from 'src/app/modules/shared/components/itinerary-details/itinerary-details.component';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { TravelItineraryViewComponent } from 'src/app/modules/shared/components/travel-itinerary-view/travel-itinerary-view.component';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

@Component({
  selector: 'app-travel-reimbursement-view',
  templateUrl: './travel-reimbursement-view.component.html',
  styleUrls: ['./travel-reimbursement-view.component.scss']
})
export class TravelReimbursementViewComponent implements OnInit {

  travel: Travel;
  user: User;
  formGroup: FormGroup;
  loading:boolean = false;
  isNoResult:boolean = false;
  show:boolean = false;
  isOther:boolean = false;
  isCharged:boolean = false;
  isCurrency:boolean = false;
  successMessage: String = '';
  total = 0;
  mealTotal = 0;
  transportFee = 0;
  currency_category = 0;
  charge_category = 0;
  totalCashAdvance = 0;
  selectedIndex = 0;

  dialogConfig:any;
  summaryDetail:any;
  detail:any;
  msg = "";
  res:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  objectKeys = Object.keys;
  expensesList:any;
  
  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];

  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }

  employeeDetail = [];

  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];
  bookedOption = BOOKINGTYPE;
  billOption = ["Store Support Center","Requestor"];

  province = [{origin:''},{destination: ''}];
  city = [{city:''},{city: ''}];
  barangay = [{barangay:'' },{barangay: ''}];
 
  pipe = new DatePipe('en-US');

  constructor(
    public dialogRef: MatDialogRef<TravelReimbursementViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public reimburseService: TravelReimbursementService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public functionService: FunctionsService,
    public travelService: TravelService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.travel = new Travel(this.data.res);
    this.detail = this.data.res;
    this.user = new User(this.auth.getAuthUser());
    this.formGroup = this.formBuilder.group({
      date_filed:['',null],
      itinerary_date: ['',null],
      travel_request: ['',null],
      travel_request_id: ['',null],
      travel_request_type: ['',null],
      employee_id: ['',null],
      employee_name: ['',null],
      booking_type: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      department: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      travel_type: ['',null],
      copy_date: ['',null],
      purpose: ['',null],
      location: ['',null],
      nature: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      currency: ['',null],
      amount: ['',null],
      charged_to: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      cash_advance_no:['',null],
      cash_advance_id:['',null],
      cash_for_reimbursement: ['',null],
      amount_for_reimbursement:['',null],
      travel_summary_id:['',null],
      misc_breakdown:['',null],
      others:['',null],
    });

    this.employeeDetail['level'] = this.travel.list.travel_request.level;
    this.employeeDetail['department'] = this.travel.list.travel_request.department;
    this.employeeDetail['area_assigned'] = this.travel.list.travel_request.area_assigned;

    this.formGroup.controls['misc_breakdown'].setValue(this.travel.misc_breakdown);
    this.travel.formGroup = this.formGroup;
    this.travel.disableForm();
    this.formGroup.controls['travel_request'].enable();
    this.formGroup.controls['misc_breakdown'].enable();
    this.formGroup.controls['is_draft'].enable();
    this.formGroup.controls['travel_request_id'].enable();
    
    this.formGroup.controls['travel_request_type'].setValue(this.travel.list.travel_request.travel_request_type);
    this.formGroup.controls['employee_id'].setValue(this.travel.list.travel_request.employee_id);
    this.formGroup.controls['employee_name'].setValue(this.travel.list.travel_request.employee_name);
    this.formGroup.controls['booking_type'].setValue(this.travel.list.travel_request.travel_summary.booking_type);
    this.formGroup.controls['employee_id_no'].setValue(this.user.employee_id);
    this.formGroup.controls['area_covered'].setValue(this.travel.list.travel_request.area_covered);
    this.formGroup.controls['position'].setValue(this.travel.list.travel_request.position);
    this.formGroup.controls['department'].setValue(this.travel.list.travel_request.department);
    this.formGroup.controls['payroll_acct_no'].setValue(this.travel.list.travel_request.payroll_acct_no);
    this.formGroup.controls['booked_by'].setValue(this.travel.list.travel_request.travel_summary.booked_by);
    this.formGroup.controls['charged_to'].setValue(this.travel.list.travel_request.travel_summary.charged_to);
    this.formGroup.controls['currency'].setValue(this.travel.list.travel_request.travel_summary.currency_category_value);
    this.formGroup.controls['currency_category'].setValue(this.travel.list.travel_request.travel_summary.currency_category);
    this.formGroup.controls['charged_to_category'].setValue(this.travel.list.travel_request.travel_summary.charged_to_category);
    this.formGroup.controls['inclusive_date_from'].setValue(this.travel.list.travel_request.travel_summary.inclusive_date_from);
    this.formGroup.controls['inclusive_date_to'].setValue(this.travel.list.travel_request.travel_summary.inclusive_date_to);
    this.formGroup.controls['location'].setValue(this.travel.list.travel_request.travel_summary.location);
    this.formGroup.controls['nature'].setValue(this.travel.list.travel_request.travel_summary.nature);
    //this.formGroup.controls['purpose'].setValue(this.travel.list.travel_request.travel_summary.purpose);
    this.formGroup.controls['travel_type'].setValue(this.travel.list.travel_request.travel_summary.travel_type);
    this.formGroup.controls['amount_for_reimbursement'].setValue(this.data.res.amount_for_reimbursement);
    this.totalCashAdvance =  this.data.res.travel_request.travel_itinerary_total.grand_total;
    this.travel.itineraries = this.data.res.travel_request.travel_itineraries;

    let purposeOption = this.travel.list.travel_request.travel_summary.purpose.split("|");
    this.formGroup.controls['purpose'].setValue(purposeOption[0]);
    this.formGroup.controls['others'].setValue( this.travel.list.travel_request.travel_summary.others);
    this.data.isOther = false;
    if (purposeOption[0] == "OTHERS") {
      this.isOther = true;
      this.data.isOther = true;
      //this.formGroup.controls['others'].setValue(purposeOption[1]);
    }
    
    this.expensesList  = this.functionService.loopRangeDate(
      [
        this.travel.list.travel_request.travel_summary.inclusive_date_from,
        this.travel.list.travel_request.travel_summary.inclusive_date_to
      ],
      this.data.res.travel_request.travel_itineraries
    );
  
    this.travel.getTotal();

   
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

  }

  
  closeOnClick() {
    this.dialogRef.close(true);
  }
  
  getTransaction(){
    let param = [];
    let queryString = '';

    if(this.formGroup.controls['travel_request'].value !== null){
      param.push('travel_request='+this.formGroup.controls['travel_request'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.reimburseService.url = reimbursementUrl+'/approved/'+ queryString;
    this.reimburseService.getFilter().subscribe(res=>{
      this.travel = new Travel(res);
      this.travel.summary_list = res.travel_summary;
      this.travel.getTotal();
      this.loading = false;
      this.isNoResult = true;
    });
  }

  save(isDraft:boolean = false){
    this.loading = true;
    this.formGroup.controls['is_draft'].setValue(isDraft);
    //this.formGroup.controls['cash_advance_id'].setValue(this.travel.list.travel_request.id);
    this.formGroup.controls['travel_summary_id'].setValue(this.travel.list.travel_request.id);
    this.formGroup.controls['travel_request_id'].setValue(this.travel.list.travel_request.id);
    
    this.formGroup.controls['travel_request'].setValue(this.travel.list.travel_request.travel_request);
    
    this.reimburseService.updateLiquidation(this.travel.id,this.formGroup.value).subscribe(res=>{
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(this.formGroup.value);
        }
      });
    },(err => {
      this.loading = false;
      this.travel.formGroup = this.formGroup;
      console.log(err)
      if (err.error.errors.mismatch) {
        var self = this;
        var emptyKey = 0;
        var continueLoop = true

        Object.keys(this.expensesList).forEach((element,i) => {
          if(this.expensesList[element].travel_itinerary_reimbursement_list.length == 0) {
            if (continueLoop) {
              emptyKey = i;
              continueLoop = false;
            }
          }
        });

        this.openLiquidation(this.expensesList[Object.keys(this.expensesList)[emptyKey]],this.expensesList)
        setTimeout(function(){
          self.dialog.open(NotifyboxComponent, {
            disableClose:true,
            data: {
              reload:false,
              label:'Ok',
              message: err.error.errors.mismatch[0]
            }
          });
        },800);
      }
      if (this.selectedIndex == 0) {
        this.selectedIndex = 1;
      }
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  saveAsDraft(){
    this.save(true);
  }

   /**
   * Delete Travel Request Data
   */
  deleteAsDraft() {
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this draft?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete();
      }
    });
  }

  delete() {
    let detail = [];
    this.loading = true;
    let data = {
      status: 'Delete as Draft',

    }
    this.reimburseService.updateStatus(this.travel.id,data).subscribe(res=>{
      
      if (this.travel.itineraries) {
        this.travel.itineraries.forEach(element => {
          if (element.travel_itinerary_reimbursement) {
            detail.push(
              {
                itinerary_liquidation: (element.travel_itinerary_reimbursement)? element.travel_itinerary_reimbursement.id : null,
                itinerary_detail_liquidation: []
              }
            );
          }
  
          element.travel_itinerary_details.forEach((el,i) => {
            if (el.travel_itinerary_detail_reimbursement) {
              detail[i].itinerary_detail_liquidation.push({id:el.travel_itinerary_detail_reimbursement.id});
            }
          });
        }); 
      }
  
      if (detail.length > 0) {
        let data = {
          travel_request_id: this.formGroup.controls['travel_request_id'].value ,
          detail: detail,
          status: 'delete'
        }
        this.reimburseService.deleteliquidation(data).subscribe(res=>{
          
        });
      }
      this.loading = false;
      this.msg = "";
      this.dialog.open(NotifyboxComponent, {
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(true);
        }
      });

    },(err =>{
      this.loading = false;
    }));
  }

  close() {
    this.msg = "";
  }

  edit(){
    this.show = true;
    this.formGroup.controls['amount_for_reimbursement'].enable();
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  cancelCa(){
    this.dialogConfig.width = '800px';
    this.dialogConfig.data = {
      id: this.data.res.id
    }
    let dialogRef = this.dialog.open(TravelReimbursementCancelComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.travel.list.ca_status = result.ca_status;
        this.travel.status_id = result.status_id;
        this.dialogRef.close(true);
      }
    });
  }

   /**
   * Open liquidaiton Detail
   */
  openLiquidation(res,detail){
    this.dialogConfig.width = '100vw';
    this.dialogConfig.panelClass = 'my-full-screen-dialog';
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = {
      module_id: this.travel.id,
      res,
      detail,
      mode:1,
      status_id: this.data.res.status_id,
      isEdit: this.show,
      reimbursement_id: this.data.res.id,
      type:'reimbursement',
      url:itineraryRBUrl
    }

    let dialogRef = this.dialog.open(ItineraryDetailsComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.travel.clearTotal();
        this.travel.itineraries = result.travel_itineraries ? result.travel_itineraries : result.travel_request.travel_itineraries;
        const travel_summary = result.travel_summary ? result.travel_summary : result.travel_request.travel_summary;
        this.expensesList  = this.functionService.loopRangeDate(
          [travel_summary.inclusive_date_from,travel_summary.inclusive_date_to],
          this.travel.itineraries
        );
        this.travel.getTotal();
      }
    });
  }

  /**
   * Display Currency option
   * @param e = 3 get value for other currency
   */
  displayCurrency(e) {
    this.isCurrency = false;
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCurrency = true;
      }
    })
  }

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.isCharged = false;
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCharged = true;
      }
    })
  }

  /**
   * View itinerary Details Modal
   * @param res 
   */
  viewItinerary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 1,
      displayEdit: false
    }
    let dialogRef = this.dialog.open(TravelItineraryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  back(e){
    this.selectedIndex=e;
  }

  next(e){
    this.selectedIndex=e;
  }
}
